import { createApi } from "./helper";
import Cookie from "js-cookie";
import mbFetch from "mibaby-common/util/fetch";
import { useSelector } from "react-redux";

export const { request: STATE_REQUEST, success: STATE_SUCCESS, error: STATE_ERROR, reducer } = createApi("profile/state", { user: { loggedIn: false } });

/**
 * @param {import("ssr").Metadata?} metadata
 */
export const fetchUserState = metadata => dispatch => {
    if (Cookie.get("login[status]") == 1) {
        dispatch({ type: STATE_REQUEST, user: { loggedIn: true } });

        // Try to get user data from SSR cache, if available
        const key = '["users.me",[]]';
        const user = metadata?.reactQueryDataUser?.[key] ?? metadata?.reactQueryData?.[key];

        return (user ? Promise.resolve(user) : mbFetch("/users/me").then(r => r.json()))
            .then(({ picture_public, ...props }) => ({ loggedIn: true, image: picture_public, ...props }))
            .then(user => {
                dispatch({ type: STATE_SUCCESS, user });
            });
    } else {
        dispatch({ type: STATE_SUCCESS, user: { loggedIn: false } });
        return Promise.resolve();
    }
};

export const useUser = () => useSelector(state => state.profile.user);
